import { FilePreviewProps } from './types'
import { useGetLanguage } from 'hooks/use-get-language'
import { formatFileSize } from '@boltenergy-be/design-system'

const FilePreview = ({ file }: FilePreviewProps) => {
  // i18n
  const language = useGetLanguage()

  // Constants
  const filename = file.name
  const lastDot = filename.lastIndexOf('.')
  const name = lastDot !== -1 ? filename.substring(0, lastDot) : filename
  const extension = lastDot !== -1 ? filename.substring(lastDot + 1) : ''

  return (
    <div key={file.name}>
      <dt>{name}</dt>
      <dd className="text-sm text-subdued">
        {formatFileSize(file.size, language)} - {extension}
      </dd>
    </div>
  )
}

export default FilePreview
